export default __webpack_public_path__ + "static/media/dbc.801eab9c.svg";